import React, { Component } from 'react';
import { DataEtage } from '../../data/DataEtage';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxEtage extends Component {

    static defaultProps = {
        idOperation: undefined,
        label: "Étage",
        placeholder: "Étage",
    };


    render = () => {

        const { idOperation } = this.props;

        // En date du 27/09/2022 il n'existe pas en BDD de table Etage :
        // Si l'idOperation est fourni alors on retourne les étages déclarés dans les lots de l'opération en question
        // Sinon on retourne une liste d'étages inscrite en dur ici
        let fetchMethod = null
        if (!!idOperation) fetchMethod = () => DataEtage._chargementEtages({ idOperation });
        else fetchMethod = () => new Promise((resolve, reject) => {
            const etages = ["R-5", "R-4", "R-3", "R-2", "R-1", "RDC", "RDJ", "R+1", "R+2", "R+3", "R+4", "R+5", "R+6", "R+7", "R+8", "R+9", "R+10", "R+11", "R+12", "R+13", "R+14", "R+15", "R+16", "R+17", "R+18"];
            resolve({ codeRetour: 0, reponseAPIobjet: etages });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item}
            itemText={item => item}
            stamp={idOperation}
        />;

    };

};